<template>
    <v-card :loading="loading" min-height="500" flat mx-2>
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-container class="px-10" fluid v-if="!loading">
            <form autocomplete="off">
                <v-row>
                    <v-col cols="4">
                        <v-card elevation="2">
                            <v-card-title>Detalii deviz</v-card-title>
                            <v-card-text>
                                <v-text-field
                                    v-model="form.document_no"
                                    :error-messages="errorMessages('document_no')"
                                    :class="{ 'error--text': hasErrors('document_no') }"
                                    class="primary--text"
                                    name="document_no"
                                    label="Numar deviz"
                                    data-vv-as="Numar deviz"
                                    data-vv-name="document_no"
                                    hint="Lasand necompletat, acesta va fi automat asignat de sistem."
                                    persistent-hint
                                />
                                <v-combobox
                                    :items="emailSuggestions"
                                    v-model="form.data.email"
                                    :search-input.sync="form.data.email"
                                    :error-messages="errorMessages('data.email')"
                                    :class="{ 'error--text': hasErrors('data.email') }"
                                    class="primary--text"
                                    name="data.email"
                                    label="E-mail"
                                    data-vv-as="E-mail"
                                    data-vv-name="data.email"
                                    :autocomplete="`autocomplete_off_${strRandom(10)}`"
                                />
                                <v-combobox
                                    :items="phoneSuggestions"
                                    v-model="form.data.phone"
                                    :search-input.sync="form.data.phone"
                                    :error-messages="errorMessages('data.phone')"
                                    :class="{ 'error--text': hasErrors('data.phone') }"
                                    class="primary--text"
                                    name="data.phone"
                                    label="Telefon"
                                    data-vv-as="Telefon"
                                    data-vv-name="data.phone"
                                    :autocomplete="`autocomplete_off_${strRandom(10)}`"
                                />
                                <v-text-field
                                    v-model="form.data.contact_person"
                                    :error-messages="errorMessages('data.contact_person')"
                                    :class="{ 'error--text': hasErrors('data.contact_person') }"
                                    class="primary--text"
                                    name="data.contact_person"
                                    label="Persoana de contact"
                                    data-vv-as="Persoana de contact"
                                    data-vv-name="data.contact_person"
                                />
                                <v-textarea
                                    v-model="form.data.remarks"
                                    :error-messages="errorMessages('data.remarks')"
                                    :class="{ 'error--text': hasErrors('data.remarks') }"
                                    class="primary--text"
                                    name="data.remarks"
                                    label="Observatii interne"
                                    data-vv-as="Observatii interne"
                                    data-vv-name="data.remarks"
                                />
                                <v-textarea
                                    v-model="form.data.client_remarks"
                                    :error-messages="errorMessages('data.client_remarks')"
                                    :class="{ 'error--text': hasErrors('data.client_remarks') }"
                                    class="primary--text"
                                    name="data.client_remarks"
                                    label="Observatii client"
                                    data-vv-as="Observatii client"
                                    data-vv-name="data.client_remarks"
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card elevation="2">
                            <v-card-title>Detalii client</v-card-title>
                            <v-card-text>
                                <customer-modal
                                    v-model="form.customer_id"
                                    :field-errors="errorMessages('customer_id')"
                                    :initial-items="[form.customer]"
                                    @change="(customer) => form.customer = customer"
                                    :expandeable="true"
                                    :show-orders-summary="_.isNil(form.id)"
                                    show-summary
                                />
                            </v-card-text>
                        </v-card>
                        <v-card elevation="2" class="mt-3">
                            <v-card-text>
                                <v-checkbox v-model="form.data.hasDates">
                                    <template v-slot:label>
                                        Pozitiile sunt datate
                                    </template>
                                </v-checkbox>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card elevation="2">
                            <v-card-title>Actiuni</v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <template v-if="!_.isNil(form.id)">
                                                <v-btn
                                                    v-if="!_.isNil(form.id)"
                                                    block
                                                    color="info"
                                                    class="my-2"
                                                    @click="downloadOffer"
                                                >
                                                    Generare Deviz
                                                </v-btn>

                                                <v-divider class="my-4"></v-divider>
                                            </template>


                                            <v-subheader>Schimbare stare</v-subheader>

                                            <v-btn
                                                v-if="!_.isNil(form.id) && canEdit && form.status !== 'PENDING_CUSTOMER'"
                                                :disabled="!isDocumentOwner"
                                                block
                                                color="warning"
                                                class="my-2"
                                                @click="setStatus('PENDING_CUSTOMER')"
                                            >
                                                Status: In asteptare
                                            </v-btn>

                                            <v-btn
                                                v-if="!_.isNil(form.id) && canEdit"
                                                :disabled="!isDocumentOwner"
                                                block
                                                color="error"
                                                class="my-2"
                                                @click="setStatus('CANCELED')"
                                            >
                                                Status: Anulat
                                            </v-btn>

                                            <v-btn
                                                v-if="!_.isNil(form.id) && hasRole('admin')"
                                                block
                                                color="success"
                                                class="my-2"
                                                @click="setStatus('INVOICED')"
                                            >
                                                Status: Facturat
                                            </v-btn>

                                            <v-subheader>Actiuni</v-subheader>
                                            <v-btn
                                                v-if="canEdit"
                                                :loading="form.busy"
                                                :disabled="errors.any() || form.busy"
                                                block
                                                color="success"
                                                class="my-2"
                                                @click="submit()"
                                            >
                                                <v-icon left>
                                                    save
                                                </v-icon>
                                                Salveaza
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card elevation="2">
                            <v-card-title>Produse si servicii</v-card-title>
                            <v-card-text>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead class="offer-thead">
                                        <tr>
                                            <th class="text-left" width="150">
                                                Tip
                                            </th>
                                            <th class="text-left">
                                                Denumire
                                            </th>
                                            <th v-if="form.data.hasDates" class="text-left">
                                                Data
                                            </th>
                                            <th class="text-left" width="50">
                                                Cantitate
                                            </th>
                                            <th class="text-left" width="50">
                                                UM
                                            </th>
                                            <th class="text-left" width="100">
                                                PU Ofertat<br/>RON
                                            </th>
                                            <th class="text-left" width="100">
                                                PU Ofertat cu TVA<br/>RON
                                            </th>
                                            <th class="text-right" width="50">
                                                <v-btn :disabled="!canEdit" color="success" x-small @click="addProduct(undefined)">Adaugare</v-btn>
                                            </th>
                                        </tr>
                                        </thead>
                                        <v-construction-estimate-row
                                            v-for="(product, index) in form.products"
                                            :key="`product-${index}`"
                                            :value="product"
                                            :index="index"
                                            :has-errors="hasErrors"
                                            :error-messages="errorMessages"
                                            :can-edit="canEdit"
                                            :has-dates="form.data.hasDates"
                                            @input="(val) => form.products[index] = val"
                                            @addChild="addChild($event)"
                                            @deleteChild="deleteChild($event)"
                                            @delete="deleteProduct(index)"
                                        />
                                        <tfoot>
                                        <tr>
                                            <td :colspan="hasDates ? 4 : 3">Total</td>
                                            <td>{{ _.sumBy(form.products, (product) => parseFloat(product.quantity)) | number }}</td>
                                            <td></td>
                                            <td>
                                                {{ totalValueWithVat | price({currency: 'RON'}) }}
                                            </td>
                                            <td>
                                                <v-btn :disabled="!canEdit" color="success" x-small @click="addProduct(undefined)">Adaugare</v-btn>
                                            </td>
                                        </tr>
                                        </tfoot>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </form>
        </v-container>
    </v-card>
</template>

<script>
    import VConstructionEstimateRow from 'Components/common/ConstructionEstimate/VConstructionEstimateRow'
    import CustomerModal from 'Components/modal/CustomerModal'
    import validationError from "Mixins/validation-error";
    import ACL from "Mixins/acl";
    import {Form} from "vform";
    import throttle from 'lodash/throttle'
    import { createNamespacedHelpers } from "vuex";
    const { mapGetters } = createNamespacedHelpers("auth");
    const { mapMutations } = createNamespacedHelpers("temp");

    export default {
        mixins: [validationError, ACL],
        components: {
            CustomerModal,
            VConstructionEstimateRow
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                customer_id: null,
                document_no: null,
                offer_date: null,
                status: null,
                customer: {
                    summary: {
                        emails: [],
                        phones: [],
                        delegates: []
                    }
                },
                products: [],
                created_by: null,
                data: {
                    contact_person: null,
                    email: null,
                    phone: null,
                    remarks: null,
                    client_remarks: null,
                    hasDates: false
                },
            })
        }),
        computed: {
            ...mapGetters({
                getMe: "getMe"
            }),
            canEdit() {
                if (this._.isNil(this.form.id)) return true
                if (this.hasRole('admin')) return true
                if ((!this._.isNil(this.form.status) && ['CANCELED', 'FINALIZED'].indexOf(this.form.status) >= 0)) return false
                if (!this.isDocumentOwner) return false
                return true
            },
            isDocumentOwner() {
                if (this._.isNil(this.form.id)) return true
                return !this._.isNil(this.form.created_by) && this.getMe?.id === this.form.created_by || this.hasRole('admin')
            },
            emailSuggestions() {
                return Object.values(this.form.customer?.summary?.emails || {})
            },
            phoneSuggestions() {
                return Object.values(this.form.customer?.summary?.phones || {})
            },
            totalValueWithVat() {
                return this._.sumBy(this.form.products, (product) => { return parseFloat(product.quantity) * parseFloat(product.unit_price_with_vat)})
            },
            totalValue() {
                return this._.sumBy(this.form.products, (product) => { return parseFloat(product.quantity) * parseFloat(product.unit_price)})
            },
        },
        watch: {
            'form.customer': {
                handler(val) {
                    if(val?.id) {
                        this.form.customer_id = val.id
                    }
                },
                deep: true
            }
        },
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
            if(this.form.products.length < 1) {
                this.addProduct(undefined)
            }
            switch (this.$route.hash) {
                case '#download-offer':
                    this.downloadOffer()
                    break
            }
        },
        methods: {
            ...mapMutations({
                addSupplier: "addSupplier"
            }),
            loadResource: throttle(async function (val) {
                let self = this;
                this.loading = true;

                let data = await this.$db.ConstructionEstimate
                    .include('customer', 'products.children')
                    .find(this.id)
                    .then(({data}) => {
                        return data
                    })
                self.form = new Form(data)
                this.loading = false
            }, 500),
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.ConstructionEstimate(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        self.form.errors.set({})
                        this.showSuccess();
                        if (this._.isNil(model.id) && response?.id) {
                            self.$nextTick(() => self.$router.push({name: "construction-estimates-edit", params: {id: response.id}}));
                        } else {
                            self.loadResource()
                        }
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            },
            async setStatus(status) {
                this.loading = true
                await axios.post(route('construction-estimates.set-status', {
                    workstation: this.form.workstation_id,
                    offerId: this.form.id,
                    status: status
                })).then(async () => {
                    await this.loadResource()
                }).finally(() => {
                    this.loading = false
                })
            },
            addProduct(index) {
                let definition = {
                    id: null,
                    type: null,
                    name: null,
                    product_number: null,
                    quantity: 1,
                    measurement: 'BUC',
                    unit_price: 0,
                    unit_price_with_vat: 0,
                    remarks: null,
                    children: []
                }
                if (index) {
                    this.form.products.splice(index, 0, definition);
                } else {
                    this.form.products.push(definition);
                }
            },
            deleteProduct(index) {
                if(this.form.products.length > 1) {
                    this.form.products.splice(index, 1);
                }
            },
            addChild({index, type}) {
                if (!(this.form.products[index].children instanceof Array)) {
                    this.form.products[index].children = []
                }
                this.form.products[index].children.push({
                    id: null,
                    type: type,
                    name: null,
                    product_number: null,
                    quantity: 1,
                    measurement: 'BUC',
                    unit_price: 0,
                    unit_price_with_vat: 0,
                    remarks: null
                })
            },
            deleteChild({index, childIndex}) {
                console.log(index, childIndex)
                this.form.products[index].children.splice(childIndex, 1);
            },
            async downloadOffer() {
                const downloadEndpoint = new this.$db.ConstructionEstimate({id: this.form.id}).downloadEndpoint
                this.loading = true
                await this.downloadFile(downloadEndpoint)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
                await this.loadResource()
                this.loading = false
            }
        }
    };
</script>

<style lang="scss">
    .offer-tbody {
        tr {
            td {
                padding: 0 5px !important;
                .v-text-field__details {
                    display: none !important;
                    &.show {
                        display: block !important;
                    }
                }
            }
        }
    }
    .offer-thead {
        tr {
            th {
                position: sticky;
                top: 0;
            }
        }
    }
</style>
